import React, { ReactElement } from "react";
import ActionSheet from "../ActionSheet";
import IC_CLOSE_WIN from "@/assets/common/ic_close_win.svg?react";

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  children: ReactElement;
}

const BottomActionSheet: React.FC<IProps> = ({
  visible,
  setVisible,
  children,
  title,
}) => {
  const handleCloseSelect = () => {
    setVisible(false);
  };

  return (
    <ActionSheet visible={visible} setVisible={setVisible}>
      <div className="w-full fixed bottom-0 bg-white rounded-4 rounded-b-0 pb-8.5 text-mx-secondary text-4 text-center">
        <div className="relative font-500 text-mx-secondary h-12.5 lh-12.5 b-b-1px b-b-solid b-#F4F6F9 mb-4">
          <IC_CLOSE_WIN
            className="absolute left-6 top-50% translate-y--50% size-6"
            onClick={handleCloseSelect}
          />
          <div className="mx-text-ellipsis max-w-70% mx-auto">{title}</div>
        </div>
        {children}
      </div>
    </ActionSheet>
  );
};

export default BottomActionSheet;
